import { Component, OnInit, OnDestroy } from '@angular/core';
import { Client } from '../../interfaces/Client.interface';
import { LoginService } from '../../services/login.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ScoreService } from '../../services/score.service';
import { TranslateService } from '@ngx-translate/core';
import { CatalogoService } from '../../services/catalogo.service';
import { Image } from '../../interfaces/Product.interface';
import { EnceService } from '../../services/ence.service';

declare var $: any;

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    providers: [LoginService, ScoreService, CatalogoService, EnceService]
})
export class NavbarComponent implements OnInit, OnDestroy {
    public infuser: Client | null = null;
    public textCategory: string = '';
    public textLevel: string = '';
    public showmenu: boolean = false;
    public showprofile: boolean = false;
    public scoresilvicola: string = '0';
    public scoreludico: string = '0';
    public userProfile: string = '';
    public selIdioma: string = '0';

    public languajes: { id: string, name: string }[] = [
        { "id": '0', "name": "Idioma" },
        { "id": 'es', "name": "Español" },
        { "id": 'ga', "name": "Gallego" }
    ];

    public dataActivatedRute: any;
    public pageNow: string = '';
    public pageLater: string = '';
    public objSession: any;
    public intervalRefresh: any;
    public valueLang: string = '';
    public valueLangAux: string = '';
    public productsSil: Array<any> = [];
    public productsLud: Array<any> = [];

    constructor(
        private _loginService: LoginService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private _scoreService: ScoreService,
        private translate: TranslateService,
        private _cataService: CatalogoService,
        public _enceService: EnceService
    ) {
        this.showmenu = false;
        this.showprofile = false;
        this.selIdioma = this.languajes[0].id;
    }

    ngOnInit(): void {
        try {
            console.debug('[NavbarComponent] Iniciando componente');
            const infoClientStr = localStorage.getItem('infoClient');

            if (!infoClientStr) {
                console.warn('[NavbarComponent] No se encontró información del cliente en localStorage');
                this.handleNoUserInfo();
                return;
            }

            console.debug('[NavbarComponent] Información del cliente encontrada:', infoClientStr);
            this.infuser = JSON.parse(infoClientStr);

            if (!this.infuser || !this.infuser.info) {
                console.warn('[NavbarComponent] La información del cliente no tiene la estructura esperada:', this.infuser);
                this.handleNoUserInfo();
                return;
            }

            console.debug('[NavbarComponent] Estructura del cliente válida:', {
                hasInfo: !!this.infuser.info,
                hasLevel: !!this.infuser.level,
                hasCategory: !!this.infuser.category,
                scores: {
                    silvicola: this.infuser.info.val_score,
                    ludico: this.infuser.info.val_score_lud
                }
            });

            this.initializeUserData();
            this.setupEventListeners();
            this.initializeProducts();
        } catch (error) {
            console.error('[NavbarComponent] Error en la inicialización:', error);
            this.handleNoUserInfo();
        }
    }

    private handleNoUserInfo(): void {
        console.warn('No hay información de usuario disponible');
        this.router.navigate(['/login']);
    }

    private initializeUserData(): void {
        if (!this.infuser) return;

        this.scoresilvicola = this.infuser.info.val_score || '0';
        this.scoreludico = this.infuser.info.val_score_lud || '0';

        if (this.infuser && this.infuser.level && this.infuser.level.name && this.infuser.level.name !== "Ninguno") {
            const categoryName = this.infuser.category && this.infuser.category.name ? this.infuser.category.name : '';
            this.userProfile = categoryName + " - " + this.infuser.level.name;
        }

        this.refreshScoreHeader();
        this.setStringCategory();
        this.setAnalyticsValue('Inicio');
    }

    private setupEventListeners(): void {
        this.router.events.subscribe(val => {
            if (val instanceof NavigationEnd && this.activatedRoute.firstChild) {
                this.activatedRoute.firstChild.data.subscribe(data => {
                    this.setAnalyticsValue(data.title || 'Desconocido');
                });
            }
        });

        this.setupLanguageInterval();
    }

    private setupLanguageInterval(): void {
        this.valueLang = sessionStorage.getItem('lang') || 'es';
        setInterval(() => {
            this.valueLangAux = sessionStorage.getItem('lang') || 'es';
            if (this.valueLang !== this.valueLangAux) {
                this.getProductsList();
                this.getProductsListLud();
                this.valueLang = this.valueLangAux;
            }
        }, 50);
    }

    ngOnDestroy(): void {
        if (this.intervalRefresh) {
            clearInterval(this.intervalRefresh);
        }
    }

    public showMenu(): void {
        this.showmenu = !this.showmenu;
        if (this.showmenu) {
            $('#navbarSide').addClass('reveal');
            $('.overlay').show();
        } else {
            $('#navbarSide').removeClass('reveal');
            $('.overlay').hide();
        }
    }

    public showProfile(): void {
        this.showprofile = !this.showprofile;
    }

    public clickLogout(): void {
        this._loginService.logout();
        this.router.navigate(['/login']);
    }

    public refreshScore(): void {
        this._scoreService.refreshScore().subscribe({
            next: (response) => {
                try {
                    const clientData = JSON.parse(localStorage.getItem('infoClient') || '');
                    if (!clientData || !clientData.info) {
                        throw new Error('No hay información del cliente');
                    }

                    const score = response[0] && response[0].score ? response[0].score.toString() : '0';
                    const scoreLud = response[0] && response[0].score_lud ? response[0].score_lud.toString() : '0';

                    clientData.info.val_score = score;
                    clientData.info.val_score_lud = scoreLud;

                    localStorage.setItem('infoClient', JSON.stringify(clientData));
                    this.scoresilvicola = clientData.info.val_score;
                    this.scoreludico = clientData.info.val_score_lud;
                } catch (error) {
                    console.error('Error al actualizar la puntuación:', error);
                }
            },
            error: (error) => {
                console.error('Error al obtener la puntuación:', error);
            }
        });
    }

    private refreshScoreHeader(): void {
        this.intervalRefresh = setInterval(() => {
            const clientStr = localStorage.getItem('infoClient');
            if (!clientStr) return;

            try {
                const client: Client = JSON.parse(clientStr);
                if (client && client.info) {
                    this.scoresilvicola = client.info.val_score;
                    this.scoreludico = client.info.val_score_lud;
                }
            } catch (error) {
                console.error('Error al actualizar puntuaciones:', error);
            }
        }, 2000);
    }

    public changeLanguaje(selectedLanguage: string): void {
        if (selectedLanguage && selectedLanguage !== '0') {
            this.selIdioma = selectedLanguage;
            sessionStorage.setItem('lang', this.selIdioma);
            this.translate.use(this.selIdioma);
        }
    }

    private initializeProducts(): void {
        this.getProductsList();
        this.getProductsListLud();
    }

    public getProductsList(): void {
        this._cataService.getProducts().subscribe({
            next: (response) => {
                console.debug('[NavbarComponent] Respuesta de getProducts:', response);
                // Asegurarse de que products sea un array
                this.productsSil = (response && !response.empty && Array.isArray(response.products)) ? response.products : [];
                if (this.productsSil && this.productsSil.length > 0) {
                    this.formatArrayProducts(this.productsSil);
                }
                localStorage.setItem('productSil', JSON.stringify(this.productsSil));
            },
            error: (error) => console.error('Error al obtener productos:', error)
        });
    }

    public getProductsListLud(): void {
        this._cataService.getProductsLudico().subscribe({
            next: (response) => {
                console.debug('[NavbarComponent] Respuesta de getProductsLudico:', response);
                // Asegurarse de que products sea un array
                this.productsLud = (response && !response.empty && Array.isArray(response.products)) ? response.products : [];
                if (this.productsLud && this.productsLud.length > 0) {
                    this.formatArrayProducts(this.productsLud);
                }
                localStorage.setItem('productLud', JSON.stringify(this.productsLud));
            },
            error: (error) => console.error('Error al obtener productos lúdicos:', error)
        });
    }

    private formatArrayProducts(arrayProductos: Array<any>): void {
        if (!arrayProductos || !Array.isArray(arrayProductos)) {
            console.warn('[NavbarComponent] formatArrayProducts recibió un array inválido:', arrayProductos);
            return;
        }

        const imageDefault: Image = {
            id: '',
            name: '',
            type: '',
            filename: '',
            url: '../../../assets/images/no-image.png',
            caption: '',
            order: '',
            entity_id: '',
            created_at: '',
            updated_at: ''
        };

        for (const product of arrayProductos) {
            if (!product.picture) {
                product.picture = imageDefault;
            }
        }
    }

    public setAnalyticsValue(pageNow: string): void {
        if (!localStorage.getItem('pageLater')) {
            this.initializeAnalytics(pageNow);
        } else {
            this.updateAnalytics(pageNow);
        }
    }

    private initializeAnalytics(pageNow: string): void {
        localStorage.setItem('pageLater', 'Login');
        this.pageLater = 'Login';
        this.sendAnalyticsData(pageNow);
    }

    private updateAnalytics(pageNow: string): void {
        this.pageNow = pageNow;
        this.pageLater = localStorage.getItem('pageLater') || '';
        this.sendAnalyticsData(pageNow);
    }

    private sendAnalyticsData(pageNow: string): void {
        const sessionData = localStorage.getItem('objsession');
        if (!sessionData) return;

        try {
            const sessionObj = JSON.parse(sessionData);
            const analyticsData = {
                session_id: sessionObj.id,
                page_before: this.pageLater,
                page_now: pageNow,
                lang: sessionStorage.getItem('lang') || 'es'
            };

            this._loginService.sendStadistic(analyticsData).subscribe({
                next: () => localStorage.setItem('pageLater', pageNow),
                error: () => console.error('Error al enviar estadísticas')
            });
        } catch (error) {
            console.error('Error al procesar datos de análisis:', error);
        }
    }

    private setStringCategory(): void {
        if (!this.infuser || !this.infuser.category || !this.infuser.category.id) return;

        setInterval(() => {
            this.updateUserProfile();
        }, 50);
    }

    public havePermissionsCatalogo(): boolean {
        return this.infuser && this.infuser.category && this.infuser.category.id === '4';
    }

    public havePermissions(): boolean {
        return this.infuser && this.infuser.category && this.infuser.category.id !== '14';
    }

    private updateUserProfile(): void {
        if (!this.infuser || !this.infuser.category || !this.infuser.category.id ||
            !this.infuser.level || !this.infuser.level.id) return;

        const categoryId = this.infuser.category.id;
        const levelId = this.infuser.level.id;

        const profileMap: { [key: string]: { [key: string]: string } } = {
            '1': {
                '1': 'ence.navbar-category-sum-emb',
                '2': 'ence.navbar-category-sum-avan',
                '3': 'ence.navbar-category-sum-est'
            },
            '2': {
                '4': 'ence.navbar-category-asoc-pla',
                '5': 'ence.navbar-category-asoc-orof',
                '6': 'ence.navbar-category-asoc-br',
                '8': 'ence.navbar-category-asoc-oroc'
            },
            '3': {
                '7': 'ence.navbar-category-aprov'
            },
            '4': {
                '14': 'ence.navbar-category-prop',
                '11': 'ence.navbar-category-prop-oro',
                '12': 'ence.navbar-category-prop-plata',
                '13': 'ence.navbar-category-prop-diamante',
                '10': 'ence.navbar-category-prop-platino'
            }
        };

        const translationKey = profileMap[categoryId] && profileMap[categoryId][levelId];
        if (translationKey) {
            this.translate.get(translationKey).subscribe(translation => {
                this.userProfile = translation;
            });
        }
    }
}
